export class UserAndCheck {
    constructor(user) {
        this.checked = false;
        this.user_data = user;
    }
}